module.exports = __webpack_public_path__ + "img/IMAGE 5.09c26513.png";